import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

import AdminButton from "./AdminButton";

export default function AdminPagination({
  page,
  totalPages,
  total,
  onPageChange,
  loading = false,
}) {
  const canPrev = page > 1;
  const canNext = page < totalPages;

  return (
    <div className="flex flex-col gap-3 border-t border-slate-200 px-4 py-4 dark:border-slate-800 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
        {loading ? "Chargement…" : `${total} résultat(s) trouvé(s)`}
      </p>

      <div className="flex items-center justify-between gap-2 sm:justify-end">
        <AdminButton
          icon={FiChevronLeft}
          variant="secondary"
          size="sm"
          disabled={!canPrev || loading}
          onClick={() => onPageChange(Math.max(page - 1, 1))}
        >
          Précédent
        </AdminButton>

        <span className="rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200">
          {page} / {totalPages}
        </span>

        <AdminButton
          rightIcon={FiChevronRight}
          variant="secondary"
          size="sm"
          disabled={!canNext || loading}
          onClick={() => onPageChange(Math.min(page + 1, totalPages))}
        >
          Suivant
        </AdminButton>
      </div>
    </div>
  );
}